'use strict';

import React from 'react'
import ReactDOM from 'react-dom'
import { i18n } from 'react-i18n'

let PropTypes = React.PropTypes

export default React.createClass({

    mixins: [i18n('common/subHeader')],

    propTypes:{
        label: React.PropTypes.string
    },

    getInitialState () {
        return {};
    },

    render () {

        let donateto = this.i18n('label.donateto')

        return (
        	<div className="col-xs-12 col-sm-12 col-md-12 donate_sub_header">
                <h4 className="text-center h4one" id="headerDonateTo">{donateto}</h4>
                <h4 className="text-center h4two" id="headerDonateToName">{this.props.label}</h4>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./common/subHeader.js
 **/